import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class QuickLinksService {
    static getAll() {
        return new Promise((resolve, reject) => {
            axios.get(`${ROOT}quick-links`).then((data) => {
                resolve({ quickLinks: data.data, response: data });
            }).catch((err) => {
                reject(err);
            });
        });
    }

    static add(quickLink) {
        return new Promise((resolve, reject) => {
            axios.post(`${ROOT}quick-links`, quickLink).then((data) => {
                resolve({ response: data });
            }).catch((err) => {
                reject(err);
            });
        });
    }

    static save(quickLink, quickLinkId) {
        return new Promise((resolve, reject) => {
            axios.patch(`${ROOT}quick-links/${quickLinkId}`, quickLink).then((data) => {
                resolve({ response: data });
            }).catch((err) => {
                reject(err);
            });
        });
    }

    static delete(quickLinkId) {
        return new Promise((resolve, reject) => {
            axios.delete(`${ROOT}quick-links/${quickLinkId}`).then((data) => {
                resolve({ response: data });
            }).catch((err) => {
                reject(err);
            });
        });
    }
}

export default QuickLinksService;
